/**
 * useDemotePlan — the read that answers "what happens if I move this off now?"
 * before the confirm dialog commits to any wording.
 *
 * Mirrors the promote flow, which also plans on click. It matters most at the
 * live floor: the answer decides whether the dialog offers a plain demote, a
 * swap naming the queued path that takes the slot, or a refusal — and asking
 * the server keeps that judgement in ONE place instead of a copy of the floor
 * rules drifting on the client.
 * For Media Devoted | Created By Ciro Autiero
 */

import { useMutation } from '@tanstack/react-query';
import type { DemotePlanResult, FlowLayer } from '@trafficpulse/shared';

import type { QueueProvider } from '@/features/trackers/flow-optimizer/queue-provider';
import { planDemote } from '../../../services/flow-optimizer-queue-api';

export interface DemotePlanInput {
  layer: FlowLayer;
  bankId: string;
}

export function useDemotePlan(
  campaignId: string,
  provider: QueueProvider = 'voluum',
) {
  return useMutation<DemotePlanResult, unknown, DemotePlanInput>({
    mutationFn: (input) => planDemote(campaignId, input, provider),
  });
}
